'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export default function ReferralTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams?.get('ref');
    if (ref && typeof window !== 'undefined') {
      localStorage.setItem('incade_referral', ref);
      // Set expiry 60 days from now
      const expiry = Date.now() + 60 * 24 * 60 * 60 * 1000;
      localStorage.setItem('incade_referral_expiry', String(expiry));
    }
    // Check expiry on load
    const expiry = localStorage.getItem('incade_referral_expiry');
    if (expiry && Date.now() > Number(expiry)) {
      localStorage.removeItem('incade_referral');
      localStorage.removeItem('incade_referral_expiry');
    }
  }, [searchParams]);

  return null;
}
